import Planting from '@/lib/planting'
import Thumbnailer from '@/lib/mapbox/thumbnailer'
import * as Constants from '@/lib/constants'

export default {
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < Constants.RESPONSIVE_BREAKPOINT_TASK_LIST
    },

    thumbnailUrl(field) {
      if (field.deleted) {
        return '/images/noField.jpg'
      }
      const thumbnailer = new Thumbnailer()
      return thumbnailer.getFieldThumbnailUrlFromGoogle(field, Constants.DEFAULT_MAP_SIZE)
    },

    listCurrentPlantings(field) {
      return Planting.listCurrentForField(field)
    },
  },
}
